import { createSelector } from 'reselect';

const selectGlobalLogisticsCatalog = (state: any) => state.globalLogisticsCatalog;


export const selectGlobalLogisticsCatalogCurrentItem = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.current);

export const selectGlobalLogisticsCatalogListItems = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalLogisticsCatalogListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalLogisticsCatalogQueryItems = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.query);

export const selectGlobalLogisticsCatalogCreatedItem = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.create);

export const selectGlobalLogisticsCatalogUpdatedItem = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.update);

export const selectGlobalLogisticsCatalogReadItem = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.read);

export const selectGlobalLogisticsCatalogDeletedItem = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.delete);

export const selectGlobalLogisticsCatalogSearchedItems = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.search);

export const selectGlobalLogisticsCatalogItemsCount = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.count);

export const selectGlobalLogisticsCatalogItemsFilter = createSelector([selectGlobalLogisticsCatalog], (globalLogisticsCatalog) => globalLogisticsCatalog.filter);